import { makeBillingClient } from '@okrapdf/protocol/http-billing-client';
import { API_ORIGIN } from '../lib/host';
import { getClerkToken } from './clerkTokenBridge';

/**
 * [A.6.5b] Singleton `/v1/billing` client — the typed effect-HttpApi client
 * from the shared contract package, bound to the dashboard's API origin and
 * Clerk token bridge. RTK Query endpoints delegate here so the request/response
 * shape is owned by `@okrapdf/protocol/http-billing`, not re-declared in-app.
 */
export const billingClient = makeBillingClient({
  baseUrl: API_ORIGIN,
  getToken: getClerkToken,
});
